/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module AlertModule
 */

const moduleName = 'alert';
const componentName = 'alert-actions-list';
const prefix = `${moduleName}.${componentName}`;

export const headerLabel = `${prefix}.headerLabel`;
export const columnTitleAlertLevel = `${prefix}.columnTitleAlertLevel`;
export const columnTitleSNMPTrap = `${prefix}.columnTitleSNMPTrap`;
export const columnTitleExternalOnly = `${prefix}.columnTitleExternalOnly`;

export const ENGLISH = {
    [headerLabel]: 'Alert Actions',
    [columnTitleAlertLevel]: 'Alert Level',
    [columnTitleSNMPTrap]: 'SNMP Trap',
    [columnTitleExternalOnly]: 'External Only',
};
